import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/i18n";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import ELearningPage from "@/pages/ELearningPage";
import FeedbackPage from "@/pages/FeedbackPage";
import InvitePage from "@/pages/InvitePage";

const ADMIN_LOGIN_PATH = "/akses-internal-aurora";
const ADMIN_DASH_PATH = "/akses-internal-aurora/dashboard";

function PublicLayout({ children }) {
  const location = useLocation();
  const hideChrome = location.pathname.startsWith("/akses-internal-aurora");
  return (
    <>
      {!hideChrome && <Navbar />}
      {children}
      {!hideChrome && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <ErrorBoundary>
              <PublicLayout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/e-learning" element={<ELearningPage />} />
                  <Route path="/kritik-saran" element={<FeedbackPage />} />
                  <Route path="/undangan/:token" element={<InvitePage />} />
                  <Route path={ADMIN_LOGIN_PATH} element={<LoginPage />} />
                  <Route path={ADMIN_DASH_PATH} element={<AdminDashboard />} />
                </Routes>
              </PublicLayout>
            </ErrorBoundary>
            <Toaster richColors position="top-right" />
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
